import styled from "styled-components";
import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";

export const DashboardBody = styled.div`
  width: 100vw;
  /* height: 1267px; */
  height: auto;
  display: flex;
  flex-direction: column;
  /* border: 2px solid blueviolet; */
  justify-content: flex-end;
  align-items: flex-end;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    width: 50%;
    gap: 0;
  }
`;

export const DashboardOuterContainer = styled.div`
  width: 1210px;
  /* height: 1100px; */
  height: auto;
  /* height: 934px; */
  /* top: 89px
left: 230px */
  /* border: 2px solid red; */
  background: var(--General-Background, #f7f7f7);
  padding: 30px;
  /* box-sizing: border-box; */

  @media screen and (max-width: 768px) {
    width: 50%;
    gap: 0;
  }
`;

export const DashboardInnerContainer = styled.div`
  width: 100%;
  height: 100%;
  /* border: 2px solid blueviolet; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 40px;
  box-sizing: border-box;
  /* overflow: scroll; */

  @media screen and (max-width: 768px) {
    width: 50%;
    // border: 2px solid red;
    gap: 0;
  }

  @media screen and (max-width: 390px) {
    width: 390px;
    padding-right: 20px;
    gap: 0;
    margin-top: 0;
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  /* border: 1px solid red; */

  /* gap: 425px; */

  @media screen and (max-width: 768px) {
    padding-top: 0;
  }

  @media screen and (max-width: 430px) {
    width: 382px;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
    padding-top: 0;
    margin-top: -50px;
  }
  @media screen and (max-width: 375px) {
    width: 327px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const TitleTextHolder = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  padding-bottom: 40px;

  /* @media screen and (max-width: 2560px) {
    display: none;
  }
  @media screen and (max-width: 1440px) {
    display: none;
  }

  @media screen and (max-width: 1024px) {
    display: none;
  }

  @media screen and (max-width: 768px) {
    display: block;
    width: 605px;
    height: 100%;
  } */

  @media screen and (max-width: 430px) {
    width: 100%;
  }

  @media screen and (max-width: 375px) {
    width: 100%;
  }
`;

export const TitleText = styled.div`
  padding-bottom: 10px;
  padding-left: 5px;
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.fontSize.heading3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
  color: ${colors.PURPLE};

  /* @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.display1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  } */
  /* @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.display2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  } */

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.body1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.body1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
    text-align: left;
  }
`;

export const SubtitleTextHolder = styled.div`
  width: 50%;

  @media screen and (max-width: 1440px) {
    width: 550px;
    height: 96px;
  }

  @media screen and (max-width: 1024px) {
    width: 400px;
    height: 100%;
  }

  @media screen and (max-width: 768px) {
    display: block;
    width: 550px;
    height: 72px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  @media screen and (max-width: 430px) {
    display: block;
    width: 327px;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  @media screen and (max-width: 375px) {
    display: block;
    width: 327px;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
`;

export const SubtitleText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
  color: ${colors.DARK_GRAY};
  padding-left: 5px;

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  /* @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  } */
`;

export const ButtonContainer = styled.div`
  width: 184px;
  height: 44px;

  @media screen and (max-width: 430px) {
    width: 184px;
    height: 44px;
    gap: 16px;
    display: flex;
    flex-direction: column;
  }

  @media screen and (max-width: 375px) {
    width: 184px;
    height: 44px;
    gap: 16px;
    display: flex;
    flex-direction: column;
  }
`;

export const PaymentLinkContainer = styled.div`
  width: 100%;
  height: auto;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid var(--General-Stroke, #e8eaed);
  background: var(--General-White, #fff);
  box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);
`;

export const TitleSearchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const PaymentLinkHeader = styled.div`
  width: 100%;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    gap: 1rem;
  }
`;

export const PaymentLinkTitleText = styled.div`
  width: 160px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
  color: ${colors.PURPLE};

  @media screen and (max-width: 430px) {
    width: 158px;
    font-size: ${fipayFonts.fipayFonts.body1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    width: 158px;
    font-size: ${fipayFonts.fipayFonts.body1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
    text-align: left;
  }
`;

export const FilterContainer = styled.div`
  display: flex;

  width: 250px;
  height: 40px;
  gap: 5px;
  align-items: center;
  /* justify-content: space-around; */
  justify-content: flex-end;
  border-radius: 8px;
  border: 1px solid var(--General-Stroke, #e8eaed);
  background: var(--General-White, #fff);
  box-sizing: border-box;
`;

export const CalendarTextHolder = styled.div`
  width: 94px;
  height: 18px;
  display: flex;
  justify-content: center;
`;

export const CalendarText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.footer1};
  color: ${colors.LIGHT_GRAY};
`;

export const CalendarLinkText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.footer1};
  color: ${colors.DARK_GRAY};
`;

export const ButtonSection = styled.div`
  width: 100%;
  height: 60px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const ExportButtonandSettingIconPhone = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;

  @media screen and (max-width: 430px) {
    display: flex;
  }
  @media screen and (max-width: 375px) {
    display: flex;
  }
`;

export const DontShowOnPhone = styled.div`
  @media screen and (max-width: 430px) {
    display: none;
  }
  @media screen and (max-width: 375px) {
    display: none;
  }
`;

export const ButtonSectionUp = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    width: 100%;
    gap: 1rem;
    flex-direction: column-reverse;
  }
`;

export const ButtonAndSettingsIcon = styled.div`
  width: 50%;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 10px;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const DoubleButton = styled.div`
  width: 50%;
  height: 40px;
  display: flex;
  box-sizing: border-box;
  gap: 10px;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const ExportDataButton = styled.div`
  display: flex;
  /* width: 95px; */
  height: 40px;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid var(--General-Stroke, #e8eaed);
  background: var(--General-White, #fff);
  box-sizing: border-box;
`;

export const ExportIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: cover;
`;

export const HorizontalLine = styled.div`
  /* width: 1130px; */
  width: 100%;
  height: 2px;
  background-color: #e8eaed;
`;

export const ButtonSectionDown = styled.div`
  width: 100%;
  height: 42px;
  display: inline-flex;
  align-items: flex-start;
  justify-content: space-between;
  /* border: 2px solid hotpink; */
  padding-left: 20px;
  /* padding-right: 20px; */
  box-sizing: border-box;
  /* gap: 680px; */
`;

export const ActiveGangButtonHolder = styled.div`
  width: 221px;
  height: 42px;
  display: inline-flex;
  align-items: flex-start;
  gap: 20px;
`;

interface NavLinkProps {
  active: boolean;
}

export const ActiveGangButton = styled.div<NavLinkProps>`
  height: 100%;
  border: none;
  cursor: pointer;
  color: ${(props) => (props.active ? "2px solid green" : "none")};
  padding-left: 10px;
  padding-right: 10px;
  border-bottom: ${(props) => (props.active ? "2px solid green" : "none")};
  transition: 1s ease;
  /* border: 2px solid red; */

  &:active {
    border-bottom: 2px solid green;
    color: green;
  }
`;

export const NavLinkText = styled.div<NavLinkProps>`
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${(props) =>
    props.active
      ? `${fipayFonts.fipayFonts.fontWeight.bold}`
      : `${fipayFonts.fipayFonts.fontWeight.regular}`};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body2};

  color: ${(props) =>
    props.active
      ? `${colors.ButtonBackgroundColors.primaryDefaultButton}`
      : "#666464"};
`;

export const PaymentAnalyticsContainer = styled.div`
  /* width: 1130px; */
  width: 100%;
  height: auto;
  flex-shrink: 0;
  border-radius: 10px;
  box-sizing: border-box;
  border: 1px solid var(--General-Stroke, #e8eaed);
  /* border: 2px solid red; */
  background: var(--General-White, #fff);
  box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);
  /* padding: 20px 50px 20px 20px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  z-index: 1;
  @media screen and (max-width: 430px) {
    width: 382px;
  }
  @media screen and (max-width: 375px) {
    width: 327px;
  }
`;

export const PaymentBigHomeChartContainer = styled.div`
  /* width: 1130px; */
  width: 100%;
  height: auto;
  flex-shrink: 0;
  border-radius: 10px;
  box-sizing: border-box;
  border: 1px solid var(--General-Stroke, #e8eaed);
  /* border: 2px solid red; */
  background: var(--General-White, #fff);
  box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);
  /* padding: 20px 50px 20px 20px; */
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  margin-top: 20px;
  z-index: 1;
  @media screen and (max-width: 430px) {
    width: 382px;
  }
  @media screen and (max-width: 375px) {
    width: 327px;
  }
`;

export const PaymentAnalyticsHeader = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 50px 20px 20px;
  box-sizing: border-box;
  /* border: 2px solid hotpink; */
  @media screen and (max-width: 430px) {
    flex-direction: column;
    gap: 10px;
  }
  @media screen and (max-width: 375px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const YearFilter = styled.div`
  position: relative;
  width: 152px;

  display: flex;
  height: 40px;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid var(--General-Stroke, #e8eaed);
  background: var(--General-White, #fff);
`;

export const FlyoutMenu = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  /* border: 2px solid black; */
  z-index: 2222;
`;

export const DropDownIcon = styled.img`
  width: 18px;
  height: 18px;
  object-fit: cover;
`;

interface DropDownMenuProps {
  isDropDown: boolean;
}

export const DropDownMenu = styled.div<DropDownMenuProps>`
  position: absolute;
  /* top: 100px;
  right: 20px; */
  /* background-color: antiquewhite; */
  background: var(--General-Background, #f7f7f7);
  border-radius: 8px;
  padding: 10px 20px;
  margin-top: 50px;
  width: 102px;
  box-sizing: border-box;
  /* overflow: scroll; */
  opacity: ${(props) => (props.isDropDown ? 1 : 0)};
  visibility: ${(props) => (props.isDropDown ? "visible" : "hidden")};
  ${(props) =>
    props.isDropDown
      ? `transform: translateY(0)`
      : `transform: translateY(-20px)`};
  transition: 0.5s ease;

  /* &::before {
    content: "";
    position: absolute;
    top: -5px;
    right: 20px;
    height: 20px;
    width: 20px;
    background: antiquewhite;
    transform: rotate(45deg);
  } */
`;

interface DropDownList {
  selected: boolean;
}

export const DropDownMenuList = styled.div<DropDownList>`
  padding: 5px 0;
  /* border-bottom: 1px solid ${colors.PURPLE}; */
  border-bottom: ${(props) =>
    props.selected ? `1px solid ${colors.PURPLE}` : "none"};
  color: ${(props) => (props.selected ? "red" : "none")};
  /* opacity: 0.5; */
  transition: 0.5;
  /* text-align: left; */
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.footer1};
  color: ${colors.LIGHT_GRAY};

  &:hover {
    color: ${colors.ButtonBackgroundColors.primaryDefaultButton};
    cursor: pointer;
  }
`;

export const EmptyDashboardContainer = styled.div`
  width: 100%;
  height: 50%;
  padding-top: 70px;
  padding-bottom: 70px;
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
`;

export const Container = styled.div`
  padding: 20px;
  background-color: white;
  width: 96.5%;

  @media screen and (max-width: 768px) {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;
